import React, { useContext, useEffect, useState } from 'react';
import { SpaceBetween, Grid, Flashbar } from '@amzn/awsui-components-react-v3';
import '../../styles/spotcp.css';
import { EmptyContent } from './emptyContent';
import { SpotcpHeader } from './header';
import { Summary } from './summary';
import { Trend } from './trend';
import { HistogramShipments } from './histogram-shipments';
import { HistogramComponents } from './histogram-components';
import { AsinAnalysis } from './asin-analysis';
import { StateContext } from './context/spotcp-context';

const SpotcpContent = (props) => {
  const {requestSubmitted, flashbarItem } = useContext(StateContext);

  const [flashbarItems, setFlashbarItems] = useState([])

  useEffect(() => {
    if (flashbarItem) {
      const dismissId = flashbarItem.id;
      setFlashbarItems(flashbarItems.concat({
        ...flashbarItem,
        onDismiss: () => setFlashbarItems(flashbarItems.filter(item => item.id !== `${dismissId}`)),
      }));
    }
  }, [flashbarItem])  

  return (
    <React.Fragment>
      <div className='spotcp-sticky-flashbar'><Flashbar items={flashbarItems}/></div>
      <div className="awsui-util-p-s">
      <SpaceBetween size="m">
        <SpotcpHeader updateTools={props.updateTools} />
        <Grid
          gridDefinition={[

            { colspan: { l: '12', m: '12', default: '12' } },
            { colspan: { l: '12', m: '12', default: '12' } },
            { colspan: { l: '6', m: '6', default: '12' } },
            { colspan: { l: '6', m: '6', default: '12' } },
            { colspan: { l: '12', m: '12', default: '12' } },
          ]}
        >
          {requestSubmitted ? (
            <React.Fragment>
              <Summary updateTools={props.updateTools}/>
              <Trend />
              <HistogramShipments updateTools={props.updateTools}/>
              <HistogramComponents updateTools={props.updateTools}/>
              <AsinAnalysis />
            </React.Fragment>
          ) : (
            <EmptyContent />
          )}
        </Grid>
      </SpaceBetween>
    </div>
    </React.Fragment>
  );
};

export default SpotcpContent;


// WEBPACK FOOTER //
// ./src/components/spotcp/contents.jsx